import _ from 'lodash';
import CrmApi from '@/lib/CrmApi';
import LandingPageSectionType from '@/enums/LandingPageSectionType';

const state = {
  design: {},
  interpolations: {},
  campaignCoupons: [],
  brandUserCoupons: [],
  brandUserCouponsUrl: null,
  productRecommendations: [],
  cartItems: [],
  unpaidOrders: [],
  totalUnpaidPrice: null
};

const mutations = {
  SET_LANDING_PAGE_DATA(state, data) {
    state.design = data.design;
    state.interpolations = data.interpolations;
    state.campaignCoupons = data.campaign_coupons;
    state.brandUserCoupons = data.brand_user_coupons;
    state.brandUserCouponsUrl = data.brand_user_coupons_url;
    state.productRecommendations = data.product_recommendations;
    state.cartItems = data.cart_items;
    state.unpaidOrders = data.unpaid_orders;
    state.totalUnpaidPrice = data.total_unpaid_price;
  }
};

function interpolate(str, interpolations) {
  if (_.isNil(str)) return '';
  return _.reduce(
    interpolations,
    (a, v, k) => a.replace(new RegExp(`%{${k}}`, 'g'), v),
    str
  );
}

const getters = {
  title({ design, interpolations }) {
    return interpolate(design.title, interpolations);
  },
  description({ design, interpolations }) {
    return interpolate(design.description, interpolations);
  },
  couponTitle({ design, interpolations }) {
    return interpolate(design.coupon_title, interpolations);
  },
  recommendationTitle({ design, interpolations }) {
    return interpolate(design.recommendation_title, interpolations);
  },
  cartTitle({ design, interpolations }) {
    return interpolate(design.cart_title, interpolations);
  },
  unpaidOrderTitle({ design, interpolations }) {
    return interpolate(design.unpaid_orders_title, interpolations);
  },
  sectionTypes(state) {
    return (state.design.section_types || []).filter(sectionType => {
      switch (sectionType) {
        case LandingPageSectionType.COUPONS:
          return (
            state.campaignCoupons.length > 0 ||
            state.brandUserCoupons.length > 0
          );
        case LandingPageSectionType.CARTS:
          return state.cartItems.length > 0;
        case LandingPageSectionType.UNPAID_ORDERS:
          return state.unpaidOrders.length > 0;
        default:
          return true;
      }
    });
  }
};

const actions = {
  fetchLandingPage({ commit, rootGetters }, { brandCode, sessionParams }) {
    const api = new CrmApi(
      brandCode,
      sessionParams,
      rootGetters.cremaDomainPrefix
    );
    return api
      .fetchLandingPage()
      .then(({ data }) => commit('SET_LANDING_PAGE_DATA', data));
  }
};

export default { namespaced: true, state, mutations, getters, actions };
